import { useTheme } from '@mui/material'

export interface CostSavingsChartColors {
  consumptionPriceColor: string
  threeSixtySavingsBatteryColor: string
  threeSixtySavingsWallboxColor: string
  dynamicEmsNormalOperationColor: string
  dynamicEmsGridChargeColor: string
  dynamicEmsBlockDischargingColor: string
}

/**
 * Config hook to set the colors for the cost saving chart
 */
export const useCostSavingChartColorSettings = (): CostSavingsChartColors => {
  const theme = useTheme()

  const colors = theme.palette.costSavingsChart

  return colors
}
